import { render, staticRenderFns } from "./pagtion.vue?vue&type=template&id=9e2c0b4a&scoped=true&"
import script from "./pagtion.vue?vue&type=script&lang=js&"
export * from "./pagtion.vue?vue&type=script&lang=js&"
import style0 from "./pagtion.vue?vue&type=style&index=0&id=9e2c0b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2c0b4a",
  null
  
)

export default component.exports